import { Faq as FaqSection } from "@components/sections";
import { Section } from "@components/ui/Section";
import { faqs } from "@data/faqs";

export default function FaqPage() {
  return (
    <>
      <Section
        eyebrow="Preguntas frecuentes"
        align="center"
        title="Resolvé tus dudas, sin vueltas"
        description={`Buscá por palabra, filtrá por categoría o explorá las ${faqs.length} respuestas más consultadas por clientes y productores.`}
        tight
      />
      <FaqSection />
    </>
  );
}
